import React, { Component } from 'react';
//import './WeightBenefitsTabs.css';
import _ from 'lodash';

class Tbody extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    render() {

        let countWT  = 0;
        let countCCWT = 0;
        let countScore = 0;
        let oldCountScore = 0;
        return (
            <tbody>
                {this.props.competeData &&  !_.isEmpty(this.props.benefitsData) && 
                this.props.competeData.map((i,index )=> {

                    if( this.props.groupId === i.groupId && this.props.segmentId === i.segmentId){
                        let benefitName = this.props.benefitsData.find(r => r.groupId === i.groupId && r.benefitId === i.benefitId );

                            // this.props.competeOldData.map((iOld,index )=> {

                                let oldI = this.props.competeOldData.find(r => r.benefitId === i.benefitId && r.segmentId === i.segmentId && r.groupId === i.groupId );

                                return (
                                    <tr>
                                        <td>
                                            <div className='td-box'>
                                                {benefitName.benefitName}
                                            </div> 
                                        </td>
                                        <td>
                                            <div className='td-box'>
                                                <input className='wt-input' type='number' value={i.wt} onChange={(e)=>this.props.onChangeWT(e, i)} />
                                                
                                                
                                                {/* { ( oldI.wt - i.wt ) !== 0 && */}
                                                    <div className="position-number">
                                                        {oldI.wt - i.wt}
                                                    </div>
                                                {/* } */}
                                                
                                            </div>
                                        </td>
                                        <td>
                                            <div className='td-box'>
                                                {i.criticalCapacity.map((critItem,index )=> {
                                                    return (
                                                    
                                                        <input disabled className={ index === 0 ?'long-box' : 'long-box'} type='text' 
                                                        value={critItem.text} 
                                                        onChange={(e)=>this.props.onChangeCriticalCapability(e, i, index)} 
                                                        />
                                                )})
                                                
                                                }  
                                                
                                            </div>
                                        </td>
                                        <td>
                                            <div className='td-box'>
                                            {i.criticalCapacity.map((critItem,index )=> {

                                                let ccWt = i.criticalCapacity.length > 1 ? critItem.ccWt : critItem.ccWt;  

                                                let oldCritItem = oldI.criticalCapacity.find(r => r.text === critItem.text  );
                                                return (
                                                <div className='td-box-small'> 
                                                    <input className='wt-input' type='number' 
                                                        value={ccWt} 
                                                        onChange={(e)=>this.props.onChangeWT(e, i)} 
                                                    />

                                                    {/* {( oldI.wt - i.wt ) !== 0 && */}
                                                            <div className="position-number">
                                                            {oldCritItem.ccWt - ccWt}
                                                        </div>
                                                    {/* }  */}
                                                </div>
                                            )})}
                                            </div>
                                        </td>
                                        <td><div className='td-box'>

                                            {i.criticalCapacity.map((critItem,index )=> {
                                                
                                                let val = critItem.rating ? critItem.rating : '0';
                                                //let val = 
                                                return <select   className='form-control' 
                                                    // value={defaultData ? defaultData.value : 1}  
                                                    onChange={(e)=>this.props.onChangeRatingValue(e, i, index)} style={{outline: 'none'}}>
                                                    <option value='1'>1</option>
                                                    <option value='2'>2</option>
                                                    <option value='3'>3</option>
                                                    <option value='4'>4</option>
                                                    <option value='5'>5</option>
                                                    <option value='6'>6</option>
                                                    <option value='7'>7</option>
                                                    <option value='8'>8</option>
                                                    <option value='9'>9</option>
                                                    <option value='10'>10</option>
                                                </select>
                                            })}
                                        </div></td>
                                        <td><div className='td-box'>
                                            {i.criticalCapacity.map((critItem,index )=> { 

                                                let valScore = critItem.rating ? +critItem.ccWt * +critItem.rating : +critItem.ccWt;
                                            
                                                countScore = +countScore + valScore;
                                                oldCountScore = oldI.totalScore

                                                return <div className='score-box'> 
                                                    {valScore}
                                                </div> 
                                            })}

                                        </div></td>
                                    </tr>
                                )
                            // })
                    }
                })} 

                <tr className='last-row'>
                    <td></td>
                    <td className='first-value'>
                        <strong>
                        { this.props.competeData.map((i,index )=> { 
                            if( this.props.groupId === i.groupId && this.props.segmentId === i.segmentId){   
                                // let oldI = this.props.competeOldData.find(r => r.benefitId === i.benefitId && r.segmentId === i.segmentId && r.groupId === i.groupId );
                                return  countWT = countWT + +i.wt
                            }
                        })}
                        </strong>
                    </td>
                    <td></td>
                    <td className=''>
                        <strong>
                            { this.props.competeData.map((i,index )=> { 
                                if( this.props.groupId === i.groupId && this.props.segmentId === i.segmentId){  
                                    if(i.criticalCapacity.length > 1){
                                        return countCCWT = countCCWT + +i.criticalCapacity[0].ccWt + +i.criticalCapacity[1].ccWt 
                                    } else{
                                        return countCCWT = countCCWT + +i.criticalCapacity[0].ccWt 
                                    }
                                }
                            })}
                        </strong>
                    </td>
                    <td></td>
                    <td className='first-value'>
                        <strong>
                            {countScore}
                        </strong>
                        {/* { ( oldI.wt - i.wt ) !== 0 && */}
                            <div className="position-number">
                                {oldCountScore - countScore}
                            </div>
                        {/* } */}
                    </td>
                </tr>
            </tbody>
        )
    }
}
export default (Tbody);


// WEBPACK FOOTER //
// ./src/components/DifferentialAdvantage/Result/WeightBenefitsTabs/Tbody/Tbody.jsx